import { ButtonToggle } from '@agilox/ui-common';
import { DetailView } from './detail-view.enum';

export const DetailViewToggles: ButtonToggle[] = [
	{ value: DetailView.DETAILS, translation: 'detail.view.details' },
	{ value: DetailView.JSON, translation: 'detail.view.json' },
];
